/* Malezia page recommendations. Independent page-only renderer extracted from the approved preview.
   No cart ownership, transport patches or experiment assignment. Optional consent-gated dashboard hooks. */
(function () {
  'use strict';
  function telemetry(event, widget, data) {
    try { if (window.MaleziaTelemetry) window.MaleziaTelemetry.track(event, widget, data); } catch (_) {}
  }
  function readJson(id) {
    var node = document.getElementById(id);
    try { return node ? JSON.parse(node.textContent) : null; } catch (_) { return null; }
  }
  var RULES = readJson('malezia-page-rules'), CATALOG = readJson('malezia-page-catalog'), PAGE = readJson('malezia-page-page') || readJson('malezia-page');
  if (!RULES || RULES.enabled !== true || !PAGE || PAGE.enabled !== true || !CATALOG) return;
  var ALLOWED = ['pdp_complete_the_look', 'pdp_customers_also_bought', 'pdp_you_may_also_like', 'home_best_sellers'];
  var REBUY_IDS = { pdp_complete_the_look: '211825', pdp_customers_also_bought: '211827', pdp_you_may_also_like: '211826', home_best_sellers: '211828' };
  var BY_ID = {}, busy = false;
  Object.keys(CATALOG).forEach(function (handle) { var p = CATALOG[handle]; if (p && p.id && p.variantId) BY_ID[String(p.id)] = p; });
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tpl(str, vars) {
    return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars && vars[k] != null ? vars[k] : '';
    });
  }
  function money(cents) {
    var fmt = PAGE.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var fixed = n.toFixed(2);
    var whole = Math.round(n);
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(whole))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(whole))
      .replace(/\{\{\s*amount\s*\}\}/g, fixed)
      .replace(/<[^>]+>/g, '');
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }
  function pluralize(n, word) { return n === 1 ? word : word + 's'; }
  function requestJson(url, opts) {
    opts = opts || {};
    var init = { method: opts.method || 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (init.method === 'GET' && /^\/cart(?:\.js|\/)/.test(url)) init.cache = 'no-store';
    if (opts.body) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(opts.body); }
    return fetch(url, init).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data && (data.description || data.message) || ('HTTP ' + r.status)); e.data = data; throw e; }
        return data;
      });
    });
  }

  /* ------------------------------------------------------- product normalising */
  // Everything renders from this shape; catalog entries already match it, and
  // /recommendations results are mapped onto it (catalog wins when the id is known).
  function fromRecommendation(p) {
    var known = BY_ID[String(p.id)];
    if (known) return known;
    var v = null;
    for (var i = 0; i < (p.variants || []).length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
    v = v || (p.variants && p.variants[0]) || {};
    return {
      id: p.id, handle: p.handle, title: p.title, url: p.url, available: !!p.available,
      price: v.price != null ? v.price : p.price, compareAtPrice: v.compare_at_price || null,
      image: p.featured_image || (p.images && p.images[0]) || '', variantId: v.id, variantTitle: v.title,
      tags: p.tags || [], badge: null, sellingPlans: []
    };
  }
  var recCache = {};
  function fetchRecommendations(seedId, intent) {
    var key = seedId + ':' + intent;
    if (!recCache[key]) {
      var url = (PAGE.root || '/').replace(/\/?$/, '/') + 'recommendations/products.json?product_id=' + seedId + '&intent=' + (intent || 'related') + '&limit=10';
      var get = function () { return requestJson(url).then(function (d) { return (d.products || []).map(fromRecommendation); }); };
      // Shopify's recommendations endpoint throws the odd 5xx (seen 3× in one QA sweep); one retry
      // after 700ms keeps the widget from silently vanishing for that page view.
      recCache[key] = get()
        .catch(function () { return new Promise(function (res) { setTimeout(res, 700); }).then(get); })
        .catch(function () { return []; });
    }
    return recCache[key];
  }

  /* ---------------------------------------------------------------- evaluator */
  function conditionMatches(c, ids) {
    var has = function (id) { return ids.indexOf(String(id)) !== -1; };
    switch (c.op) {
      case 'any': return true;
      case 'equals':
      case 'contains_any': return c.productIds.some(has);
      case 'contains_all': return c.productIds.every(has);
      case 'does_not_contain_any': return !c.productIds.some(has);
      default: return false;
    }
  }
  // ids = product ids on the page (PDP) or in the cart. Returns the matched rules
  // in order, plus the accumulated fixed ids and the first recommendation intent.
  function evaluate(widget, ids) {
    var matched = [], fixed = [], intent = null;
    for (var i = 0; i < widget.rules.length; i++) {
      var r = widget.rules[i];
      if (!r.when.every(function (c) { return conditionMatches(c, ids); })) continue;
      matched.push(r);
      if (r.output.type === 'products') fixed = fixed.concat(r.output.productIds);
      else if (!intent) intent = r.output.intent;
      if (r.exit) break;
    }
    return { matched: matched, fixed: fixed, intent: intent };
  }
  // ctx: { ids: [], seedId: string|null }
  function resolveWidget(widget, ctx) {
    var ev = evaluate(widget, ctx.ids);
    if (!ev.matched.length) return Promise.resolve(null);
    var recP = Promise.resolve([]);
    if (ev.intent) {
      if (ctx.seedId) recP = fetchRecommendations(ctx.seedId, ev.intent);
      else if (widget.emptyCartFallback === 'bestSellers30d') recP = Promise.resolve(RULES.bestSellers30d.productIds.map(function (id) { return BY_ID[id]; }).filter(Boolean));
    }
    return recP.then(function (recs) {
      if (widget.recommendationSort === 'bestSellers30d') {
        // Stable sort: ranked products first (best seller first), unranked keep API order after them.
        var rank = RULES.bestSellers30d.productIds;
        recs = recs.map(function (p, i) { var r = rank.indexOf(String(p.id)); return { p: p, k: r === -1 ? rank.length + i : r, i: i }; })
          .sort(function (a, b) { return a.k - b.k || a.i - b.i; }).map(function (x) { return x.p; });
      }
      var candidates = ev.fixed.map(function (id) { return BY_ID[id]; }).filter(Boolean).concat(recs);
      var seen = {}, out = [];
      for (var i = 0; i < candidates.length; i++) {
        var p = candidates[i], id = String(p.id);
        if (seen[id]) continue;
        seen[id] = true;
        if (widget.excludeProductIds.indexOf(id) !== -1) continue;
        if (widget.filterInputs && ctx.ids.indexOf(id) !== -1) continue;
        if (!p.available || !p.variantId || !isFinite(Number(p.price)) || Number(p.price) < 0) continue;
        out.push(p);
        if (out.length >= widget.limit) break;
      }
      if (!out.length) return null;
      // Title: first matched rule that still contributes a product after filtering.
      var title = ev.matched[0].title;
      for (var j = 0; j < ev.matched.length; j++) {
        var r = ev.matched[j];
        var contributes = r.output.type === 'products'
          ? r.output.productIds.some(function (id) { return out.some(function (p) { return String(p.id) === id; }); })
          : out.some(function (p) { return ev.fixed.indexOf(String(p.id)) === -1; });
        if (contributes) { title = r.title; break; }
      }
      return { title: title, products: out };
    });
  }

  function priceHtml(p, plan) {
    var price = plan ? plan.price : p.price;
    var compare = plan ? p.price : p.compareAtPrice;
    if (compare && compare > price) {
      // Sale price first, then the struck compare-at (matches Rebuy's .rebuy-money.sale / .compare-at order)
      return '<div><span class="mpg-money mpg-money--sale">' + money(price) + '</span><span class="mpg-money mpg-money--compare">' + money(compare) + '</span></div>';
    }
    return '<div><span class="mpg-money">' + money(price) + '</span></div>';
  }
  function reviewData(p) {
    // Judge.me preview badge metafield → { rating, count }. Same source Rebuy reads.
    if (!p.badge) return null;
    var r = /data-average-rating=['"]([\d.]+)['"]/.exec(p.badge);
    var n = /data-number-of-reviews=['"](\d+)['"]/.exec(p.badge);
    if (!r || !n || !parseInt(n[1], 10)) return null;
    return { rating: parseFloat(r[1]), count: parseInt(n[1], 10) };
  }
  function formatCount(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function starsHtml(p) {
    var rv = reviewData(p);
    if (!rv) return '';
    var pct = Math.max(0, Math.min(rv.rating / 5 * 100, 100));
    return '<div class="mpg-review">' +
      '<span class="mpg-stars" role="img" aria-label="' + rv.rating + ' out of 5 stars"><span class="mpg-stars__bg"></span><span class="mpg-stars__fg" style="width:' + pct + '%"></span></span>' +
      '<span class="mpg-review__count"><span>' + formatCount(rv.count) + '</span> <span>' + pluralize(rv.count, 'Review') + '</span></span>' +
    '</div>';
  }
  function addButtonHtml(p, widget, extraClass) {
    var addLabel = widget.addToCartLabel || 'Add to cart';
    return '<button type="button" class="mpg-btn' + (extraClass ? ' ' + extraClass : '') + '" data-mpg-add="' + p.variantId + '" data-mpg-stamp="' + esc(widget.stamp) + '"' + (p.available ? '' : ' disabled') + '>' + esc(p.available ? addLabel : 'Sold out') + '</button>';
  }
  // Rebuy product block: media / info (title, stars, price) / actions.
  function cardHtml(p, widget) {
    return '<div class="mpg-block mpg-card" data-mpg-product="' + p.id + '">' +
      '<div class="mpg-block__media"><a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400"></a></div>' +
      '<div class="mpg-block__info">' +
        '<h5 class="mpg-block__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h5>' +
        starsHtml(p) +
        '<div class="mpg-block__price" data-mpg-price>' + priceHtml(p, null) + '</div>' +
      '</div>' +
      '<div class="mpg-block__actions">' + addButtonHtml(p, widget) + '</div>' +
    '</div>';
  }
  var ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="20" height="20" focusable="false" aria-hidden="true"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg>';
  var PLUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" focusable="false" aria-hidden="true"><path d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"></path></svg>';
  /* ---------------------------------------------------------------- widgets */
  function widgetShell(widget, title, tag) {
    var node = el('<section class="mpg-widget mpg-widget--' + widget.layout + ' mpg-widget--' + widget.id + '" data-mpg-widget="' + widget.id + '"' + '><' + tag + ' class="mpg-widget__title">' + esc(title) + '</' + tag + '></section>');
    return node;
  }
  function columnsFor(widget) {
    var cols = widget.columns || { large: 4, medium: 2, small: 2 };
    var w = window.innerWidth;
    return w >= 1000 ? cols.large : w >= 768 ? cols.medium : cols.small;
  }
  // Splide-style carousel: fixed-width slides, translateX track, page-by-page
  // chevron arrows that rewind at the ends (Rebuy's prev reads "Go to last slide"),
  // hidden when everything fits.
  function renderCarousel(root, widget, products) {
    var cols = widget.columns || { large: 4, medium: 2, small: 2 };
    var c = el('<div class="mpg-carousel" style="--mpg-cols:' + cols.large + ';--mpg-cols-medium:' + cols.medium + ';--mpg-cols-small:' + cols.small + '">' +
      '<div class="mpg-carousel__arrows"><button type="button" class="mpg-carousel__arrow mpg-carousel__arrow--prev" aria-label="Previous slide">' + ARROW_SVG + '</button>' +
      '<button type="button" class="mpg-carousel__arrow mpg-carousel__arrow--next" aria-label="Next slide">' + ARROW_SVG + '</button></div>' +
      '<div class="mpg-carousel__track"><ul class="mpg-carousel__list"></ul></div></div>');
    var list = c.querySelector('.mpg-carousel__list'), track = c.querySelector('.mpg-carousel__track');
    var prev = c.querySelector('.mpg-carousel__arrow--prev'), next = c.querySelector('.mpg-carousel__arrow--next');
    products.forEach(function (p) { list.appendChild(el('<li class="mpg-carousel__slide">' + cardHtml(p, widget) + '</li>')); });
    var index = 0;
    function update() {
      var per = columnsFor(widget), n = products.length;
      var max = Math.max(n - per, 0);
      index = Math.min(index, max);
      list.style.transform = 'translateX(' + (-index * track.clientWidth / per) + 'px)';
      prev.setAttribute('aria-label', index <= 0 ? 'Go to last slide' : 'Previous slide');
      next.setAttribute('aria-label', index >= max ? 'Go to first slide' : 'Next slide');
      c.querySelector('.mpg-carousel__arrows').classList.toggle('mpg-carousel__arrows--hidden', n <= per);
    }
    function maxIndex() { return Math.max(products.length - columnsFor(widget), 0); }
    prev.addEventListener('click', function () { index = index <= 0 ? maxIndex() : Math.max(index - columnsFor(widget), 0); update(); });
    next.addEventListener('click', function () { index = index >= maxIndex() ? 0 : Math.min(index + columnsFor(widget), maxIndex()); update(); });
    // Swipe, like Splide's `drag` on Rebuy's carousels: the list follows the finger, then snaps one
    // page in the swipe direction (>40px) or back. Vertical panning stays native (CSS touch-action).
    var startX = null, moved = 0, dragging = false, suppressClick = false;
    function pageOffset() { return -index * track.clientWidth / columnsFor(widget); }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX; moved = 0; dragging = false;
    });
    track.addEventListener('pointermove', function (e) {
      if (startX == null) return;
      moved = e.clientX - startX;
      if (!dragging && Math.abs(moved) > 8) { dragging = true; list.style.transition = 'none'; }
      if (dragging) list.style.transform = 'translateX(' + (pageOffset() + moved) + 'px)';
    });
    function endDrag() {
      if (startX == null) return;
      var per = columnsFor(widget);
      if (dragging && Math.abs(moved) > 40) index = moved < 0 ? Math.min(index + per, maxIndex()) : Math.max(index - per, 0);
      if (dragging) { suppressClick = true; setTimeout(function () { suppressClick = false; }, 300); }
      startX = null; dragging = false; list.style.transition = '';
      update();
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { track.addEventListener(t, endDrag); });
    track.addEventListener('click', function (e) { if (suppressClick) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); }); // no native image ghost-drag
    window.addEventListener('resize', update);
    root.appendChild(c);
    update();
  }
  function renderGrid(mount, widget, result) {
    mount.innerHTML = '';
    var root = widgetShell(widget, result.title, 'h4');
    if (widget.layout === 'carousel') {
      renderCarousel(root, widget, result.products);
    } else {
      var grid = el('<div class="mpg-grid mpg-grid--' + widget.layout + '"></div>');
      result.products.forEach(function (p) { grid.appendChild(el(cardHtml(p, widget))); });
      root.appendChild(grid);
    }
    mount.appendChild(root);
    mount.removeAttribute('hidden');
  }
  // Dynamic bundle: image row (mobile) / product columns with a checkbox under
  // each image (desktop), unchecked items fade to 30%, one combined price + CTA.
  function renderBundle(mount, widget, result) {
    var main = PAGE.productId ? BY_ID[String(PAGE.productId)] : null;
    var items = (main && main.available && main.variantId ? [main] : []).concat(result.products).filter(function (p, i, list) { return list.findIndex(function (x) { return String(x.id) === String(p.id); }) === i; });
    mount.innerHTML = '';
    var root = widgetShell(widget, result.title, 'h3');
    function actionsHtml(kind) {
      return '<div class="mpg-bundle__actions mpg-bundle__actions--' + kind + '">' +
        '<div class="mpg-bundle__actions-price"><strong>Total Price:</strong> <span class="mpg-bundle__total" data-mpg-bundle-total></span></div>' +
        '<div class="mpg-bundle__actions-buttons"><button type="button" class="mpg-btn" data-mpg-bundle-add>' + esc(widget.addToCartLabel) + '</button></div></div>';
    }
    var bundle = el('<div class="mpg-bundle"><div class="mpg-bundle__images"></div><div class="mpg-bundle__items"></div>' + actionsHtml('mobile') + '</div>');
    var images = bundle.querySelector('.mpg-bundle__images'), wrap = bundle.querySelector('.mpg-bundle__items');
    items.forEach(function (p, i) {
      images.appendChild(el('<div class="mpg-bundle__image" data-mpg-image="' + p.id + '"><a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400"></a><span class="mpg-bundle__divider">' + PLUS_SVG + '</span></div>'));
      var card = el('<div class="mpg-bundle__item mpg-block mpg-card" data-mpg-product="' + p.id + '" data-mpg-variant="' + p.variantId + '">' +
        '<div class="mpg-bundle__info">' +
          '<div class="mpg-bundle__image-item"><a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400"></a></div>' +
          '<div class="mpg-bundle__checkbox"><label><input type="checkbox" class="mpg-checkbox" checked data-mpg-bundle-check><span class="mpg-sr">Include ' + esc(p.title) + '</span></label></div>' +
          '<div class="mpg-bundle__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></div>' +
          starsHtml(p) +
          '<div class="mpg-bundle__price">' + priceHtml(p, null) + '</div>' +
        '</div></div>');
      wrap.appendChild(card);
    });
    root.appendChild(bundle);
    root.appendChild(el(actionsHtml('desktop')));
    function total() {
      var sum = 0, compare = 0, any = false;
      wrap.querySelectorAll('.mpg-bundle__item').forEach(function (card) {
        var on = card.querySelector('[data-mpg-bundle-check]').checked;
        card.classList.toggle('is-unchecked', !on);
        var img = images.querySelector('[data-mpg-image="' + card.getAttribute('data-mpg-product') + '"]');
        if (img) img.classList.toggle('is-unchecked', !on);
        var bp = items.filter(function (p) { return String(p.id) === card.getAttribute('data-mpg-product'); })[0] || {};
        if (on) { any = true; sum += bp.price || 0; compare += Math.max(bp.compareAtPrice || 0, bp.price || 0); }
      });
      // Rebuy: when any checked item is on sale the total reads "$129.10 <s>$131.70</s>" (sale + struck compare-at).
      root.querySelectorAll('[data-mpg-bundle-total]').forEach(function (t) { t.innerHTML = moneySpans(sum, compare); });
      root.querySelectorAll('[data-mpg-bundle-add]').forEach(function (b) { b.disabled = busy || !any; });
    }
    wrap.addEventListener('change', total);
    total();
    root.querySelectorAll('[data-mpg-bundle-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var lines = [];
        wrap.querySelectorAll('.mpg-bundle__item').forEach(function (card) {
          if (card.querySelector('[data-mpg-bundle-check]').checked) lines.push({ id: Number(card.getAttribute('data-mpg-variant')), quantity: 1, properties: stampProps(widget.id) });
        });
        if (!busy && lines.length) telemetry('click', widget.id);
        addLines(lines, root, items);
      });
    });
    mount.appendChild(root);
    mount.removeAttribute('hidden');
  }
  function moneySpans(price, compare) {
    return compare > price
      ? '<span class="mpg-money mpg-money--sale">' + money(price) + '</span><span class="mpg-money mpg-money--compare">' + money(compare) + '</span>'
      : '<span class="mpg-money">' + money(price) + '</span>';
  }

  function stampProps(widgetId) { return { _malezia_page_widget: widgetId }; }
  function cartPath(suffix) { return (PAGE.root || '/').replace(/\/?$/, '/') + 'cart' + suffix; }
  function isNativeOwner() {
    var rollout = window.MaleziaSmartCartRollout;
    return rollout && typeof rollout.ownsCart === 'function' && rollout.ownsCart();
  }
  function showCart() {
    // The existing native fetch queue normally starts its own refresh/open before
    // this callback. Never create a second owner, mutation, attribution or checkout.
    var native = window.MaleziaMerch;
    if (native && isNativeOwner()) {
      return Promise.resolve(typeof native.whenCartIdle === 'function' ? native.whenCartIdle() : null).then(function () {
        if (!isNativeOwner()) return; // existing router owns any rollback/reload
        var drawer = document.querySelector('[data-malezia-cart]');
        if (!drawer || drawer.hidden || drawer.getAttribute('aria-hidden') === 'true') return native.open();
      });
    }
    var rebuy = window.Rebuy;
    if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
      var fetched = rebuy.Cart && typeof rebuy.Cart.fetch === 'function' ? rebuy.Cart.fetch() : null;
      return Promise.resolve(fetched).then(function () { if (!isNativeOwner()) rebuy.SmartCart.show(); });
    }
    window.location.assign(PAGE.cartUrl || cartPath(''));
    return Promise.resolve();
  }
  function errorNode(root) {
    var node = root.querySelector('.mpg-error');
    if (!node) { node = document.createElement('p'); node.className = 'mpg-error'; node.setAttribute('role', 'status'); root.appendChild(node); }
    return node;
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('[data-malezia-page-widget] [data-mpg-add], [data-malezia-page-widget] [data-mpg-bundle-add]').forEach(function (button) {
      if (value) { button.setAttribute('data-mpg-was-disabled', button.disabled ? '1' : '0'); button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      else { button.disabled = button.getAttribute('data-mpg-was-disabled') === '1'; button.removeAttribute('data-mpg-was-disabled'); button.removeAttribute('aria-busy'); }
    });
    document.querySelectorAll('[data-malezia-page-widget] [data-mpg-bundle-check]').forEach(function (input) { input.disabled = value; });
  }
  function addLines(lines, root, products) {
    if (busy || !lines.length) return Promise.resolve(false);
    var error = errorNode(root); error.textContent = ''; setBusy(true);
    // EXACTLY one add attempt. A network error can occur after Shopify commits;
    // never retry, replay or replace the customer's cart to hide uncertainty.
    return requestJson(cartPath('/add.js'), { method: 'POST', body: { items: lines } }).then(function () {
      try {
        var addedProducts = products || Object.keys(CATALOG).map(function (handle) { return CATALOG[handle]; });
        lines.forEach(function (line) {
          var product = addedProducts.filter(function (p) { return p && String(p.variantId) === String(line.id); })[0];
          telemetry('atc', root.getAttribute('data-mpg-widget'), { product: product && product.id, variant_id: line.id, qty: line.quantity, value: product ? product.price * line.quantity : undefined });
        });
      } catch (_) {}
      return Promise.resolve(showCart()).catch(function () {
        error.textContent = 'Added to your cart. Open your cart to continue.';
      }).then(function () { return true; });
    }, function (e) {
      error.textContent = e.data ? String(e.data.description || e.data.message || 'This item could not be added.') : 'We could not confirm the addition. Check your cart before trying again.';
      var link = document.createElement('a'); link.href = PAGE.cartUrl || cartPath(''); link.textContent = ' View cart'; error.appendChild(link);
      return false;
    }).then(function (ok) { setBusy(false); return ok; }, function () { setBusy(false); error.textContent = 'Open your cart to check your items.'; return false; });
  }
  function setFallback(mount, nativeReady) {
    var id = mount.getAttribute('data-malezia-page-widget'), wrapper = mount.closest('[data-malezia-page-placement]');
    mount.hidden = !nativeReady;
    // Rebuy may relocate its anchor outside our original fallback wrapper.
    // Readiness suppresses only this exact reviewed widget wherever it moves.
    var rebuyId = REBUY_IDS[id];
    if (rebuyId) {
      var readyAttr = 'data-malezia-page-ready-' + rebuyId;
      if (nativeReady) document.documentElement.setAttribute(readyAttr, 'true');
      else document.documentElement.removeAttribute(readyAttr);
    }
    if (!wrapper || wrapper.getAttribute('data-malezia-page-placement') !== id) return;
    wrapper.querySelectorAll('[data-malezia-page-fallback]').forEach(function (fallback) {
      if (fallback.getAttribute('data-malezia-page-fallback') === id) fallback.hidden = nativeReady;
    });
  }
  function mountPageWidgets() {
    var ctx = { ids: PAGE.productId ? [String(PAGE.productId)] : [], seedId: PAGE.productId ? String(PAGE.productId) : null };
    document.querySelectorAll('[data-malezia-page-widget]').forEach(function (mount) {
      var id = mount.getAttribute('data-malezia-page-widget');
      if (mount.getAttribute('data-mpg-mounted') === '1') return;
      mount.setAttribute('data-mpg-mounted', '1'); setFallback(mount, false);
      var widget = RULES.widgets && RULES.widgets[id];
      if (ALLOWED.indexOf(id) < 0 || !widget || widget.enabled !== true || widget.surface !== PAGE.template) return;
      Promise.resolve().then(function () { return resolveWidget(widget, ctx); }).then(function (result) {
        if (!result || !result.products.length) return;
        if (widget.layout === 'bundle') renderBundle(mount, widget, result);
        else renderGrid(mount, widget, result);
        if (!mount.querySelector('.mpg-widget')) throw new Error('Missing widget');
        mount.addEventListener('click', function (e) {
          var link = e.target.closest ? e.target.closest('a[href]') : null;
          if (link && mount.contains(link)) {
            var card = link.closest('[data-mpg-product], [data-mpg-image]');
            if (card) telemetry('click', id, { product: card.getAttribute('data-mpg-product') || card.getAttribute('data-mpg-image') });
          }
          var button = e.target.closest ? e.target.closest('[data-mpg-add]') : null;
          if (!button || !mount.contains(button)) return;
          e.preventDefault();
          if (button.disabled || busy) return;
          var variant = button.getAttribute('data-mpg-add');
          var product = result.products.filter(function (p) { return String(p.variantId) === variant; })[0];
          if (!product || !product.available) return;
          telemetry('click', id, { product: product.id, variant_id: product.variantId });
          addLines([{ id: Number(product.variantId), quantity: 1, properties: stampProps(id) }], mount.querySelector('.mpg-widget'), [product]);
        });
        setFallback(mount, true);
        try { if (window.MaleziaTelemetry) window.MaleziaTelemetry.observe(mount.querySelector('.mpg-widget'), id); } catch (_) {}
      }).catch(function () { mount.innerHTML = ''; setFallback(mount, false); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountPageWidgets);
  else mountPageWidgets();
})();
